import React from 'react';
import { useTranslation } from 'react-i18next';

import { InputHandler } from '../../../../../viewer/input-handler';
import { MeasureTool } from '../../../../../viewer/tools/measure-tool';
import { SkyviewContext } from '../../../skyview/skyview-state';
import { ToolIcon } from '../tool-icon';

const MeasurementToolIcon = () => {
  const { t } = useTranslation();
  const { activeTool } = React.useContext(SkyviewContext);

  const onClick = () => {
    InputHandler.instance.setTool('measure');
  };

  return (
    <ToolIcon
      active={activeTool instanceof MeasureTool}
      callback={onClick}
      icon={['fal', 'ruler']}
      tooltip={{
        title: t('measurement.tooltip.title', { ns: 'skyviewToolbar' }),
        text: t('measurement.tooltip.text', { ns: 'skyviewToolbar' }),
      }}
    />
  );
};

export { MeasurementToolIcon };
